
export const PERIOD_TIME_UNIT = [
    { id: 1, name: "day", key: "DAYS" },
    { id: 2, name: "month", key: "MONTHS" },
    { id: 3, name: "year", key: "YEARS" }
]


/**
 * Enum defined in the backend
 */
export const PERIOD_TIME_UNIT_ENUM = {
    HOURS: {
        id: 0, name: "HOURS"
    },
    DAYS: {
        id: 1, name: "DAYS"
    },
    WEEKS: {
        id: 2, name: "WEEKS"
    },
    MONTHS: {
        id: 3, name: "MONTHS"
    },
    YEARS: {
        id: 4, name: "YEARS"
    }
}


